<template>
<!-- <div></div> -->
    <div class="card card-dashboard-fourteen" style="height:210px" v-loading='loading'>
        <label class="az-content-label">Contributions</label>
        <div class="card-body">
            <div class="row mg-t-15 mg-b-20">
            <div class="col">
                <h4>{{member_number}}</h4><label class="lb">{{member_number>1 || member_number===0?"Members":"Member"}}</label>
                <span>{{text}}</span>
                
            </div>
            </div>
        </div>
        <div class="card-footer">
            <el-select size="mini" style="width:120px;margin-right:10px" clearable v-model="b" placeholder="Select Brand">
                <el-option v-for="(brand,index) in brands" :key="index" :label="brand[1]" :value="brand"></el-option>
            </el-select>
            <span style="font-size:12px;font-weight:600">
                <el-tooltip v-if="b===''" class="item" effect="dark" content="Select a brand to view the Contributions Details" placement="top">
                    <span class="nav-sub-link"><i class="fa fa-angle-right"></i>Contributions Details</span>
                </el-tooltip>
                <router-link v-else class="nav-sub-link" :to='{path:"/adviserdashboard/contributions",query:{page:"Contributions"}}'>
                    <i class="fa fa-angle-right"></i>Contributions Details
                </router-link>
            </span>
        </div>
    </div> 
</template>
<script>
export default {
    name:"contributions",
    data(){
        return{
            b:'',
            brands:[],
            member_number:'',
            members:[],
            text:'',
            loading:true
        }
    },
    created(){
        this.getContributionData();
    },
    watch:{
        b(newVal){
            if(newVal !== ''){
                this.$store.dispatch('select_brand',newVal)
            }
        }
    },
    methods:{
        getContributionData: function(){
            // will change when BO router set up
            // let brand = this.$route.params.brand;
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.brands = userdetail['brand_list']
            let brand = localStorage.getItem('brand_code')
            this.$api.bo_api.contributions(brand).then(response =>{
                let contribution = response.data["contributions"];
                let exceeded_contribution = response.data["exceeded_contributions"]
                if(exceeded_contribution.length>0){
                    this.members = exceeded_contribution
                    this.member_number = exceeded_contribution.length
                    this.text = 'may have breached the cap'
                }else if(contribution.length>0){
                    this.members = contribution
                    this.member_number = contribution.length
                    this.member_number===1?this.text = 'is within 10% of breaching the cap'
                    :this.text = 'are within 10% of breaching the cap'
                }else{
                    this.member_number = 0
                    this.text = 'are within 10% of breaching the cap'
                }
                this.loading=false
            })
            
        },
       
    }
}
</script>
<style scoped>
.lb{
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 0;
    display: block;
    letter-spacing: .5px;
}
</style>